import React, { lazy } from 'react';
import { AlertTriangle, ClipboardList, Scale, MessageCircle, HeartPulse, Instagram } from 'lucide-react';
const bonos = [{
  icon: AlertTriangle,
  title: 'Checklist Riesgo Suicida',
  desc: '15 ítems + árbol de decisión + plan de seguridad + checklist plastificable + 5 casos resueltos',
  image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?auto=format&fit=crop&w=900&h=300&q=80',
  accent: 'bg-red-100',
  text: 'text-red-600'
}, {
  icon: ClipboardList,
  title: 'Plantilla Pase de Guardia',
  desc: 'Plantilla por paciente + resumen de turno + protocolo + registro de incidentes',
  image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=900&h=300&q=80',
  accent: 'bg-blue-100',
  text: 'text-blue-600'
}, {
  icon: Scale,
  title: 'Guía Ley 26.657',
  desc: '15 artículos clave + internación involuntaria + habeas corpus + plazos legales',
  image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=900&h=300&q=80',
  accent: 'bg-amber-100',
  text: 'text-amber-600'
}, {
  icon: MessageCircle,
  title: 'Scripts con Familiares',
  desc: 'Scripts para internación involuntaria, familiar agresivo, intento suicida y dar diagnóstico',
  image: 'https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?auto=format&fit=crop&w=900&h=300&q=80',
  accent: 'bg-purple-100',
  text: 'text-purple-600'
}, {
  icon: HeartPulse,
  title: 'Anti-Burnout Residentes',
  desc: 'Test de autoevaluación + protocolo post-guardia + manejo de casos + plan semanal',
  image: 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?auto=format&fit=crop&w=900&h=300&q=80',
  accent: 'bg-rose-100',
  text: 'text-rose-600'
}, {
  icon: Instagram,
  title: 'Pack Instagram x20',
  desc: '20 posts con copy completo + hashtags + calendario mensual + estrategia de contenido',
  image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?auto=format&fit=crop&w=900&h=300&q=80',
  accent: 'bg-fuchsia-100',
  text: 'text-fuchsia-600'
}];
export function BonosGrid() {
  return <section className="py-8 md:py-20 bg-brand-bg" data-id="element-43">
      <div className="max-w-3xl mx-auto px-4" data-id="element-44">
        <div className="text-center mb-6 md:mb-12" data-id="element-45">
          <h2 className="text-[11px] md:text-sm font-bold text-green-600 tracking-wider uppercase mb-1.5" data-id="element-46">
            INCLUIDOS GRATIS
          </h2>
          <h3 className="font-heading text-[22px] md:text-4xl text-brand-dark mb-2 md:mb-4" data-id="element-47">
            6 Bonos Clínicos
          </h3>
          <p className="text-gray-600 text-xs md:text-base" data-id="element-48">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </div>

        <div className="flex flex-col gap-3 md:gap-4 mb-6 md:mb-12" data-id="element-49">
          {bonos.map((bono, idx) => {
          const Icon = bono.icon;
          return <div key={idx} className="bg-white rounded-xl overflow-hidden border border-green-200 shadow-sm hover:shadow-lg hover:-translate-y-0.5 active:scale-[0.99] transition-all duration-300 group cursor-pointer" data-id="element-50">
                {/* Hyperrealistic representative image — 3:1 aspect ratio */}
                <div className="relative aspect-[3/1] overflow-hidden bg-gray-100" data-id="element-51">
                  <img src={bono.image} alt={bono.title} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-52" />
                  {/* Dark overlay for legibility */}
                  <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/20" data-id="element-53"></div>

                  {/* Foreground content over image */}
                  <div className="absolute inset-0 flex items-center justify-between px-4 md:px-6" data-id="element-54">
                    <div className="flex items-center gap-3 md:gap-4" data-id="element-55">
                      <div className="bg-white/15 backdrop-blur-md rounded-xl p-2 md:p-3 border border-white/30 shadow-lg" data-id="element-56">
                        <Icon className="w-5 h-5 md:w-7 md:h-7 text-white" data-id="element-57" />
                      </div>
                      <span className="text-white font-heading text-lg md:text-2xl drop-shadow-md" data-id="element-58">
                        Bono {idx + 1}
                      </span>
                    </div>

                    <span className="bg-green-500 text-white text-[10px] md:text-xs font-bold px-2 py-1 md:px-3 md:py-1.5 rounded-full uppercase tracking-wider shadow-lg" data-id="element-59">
                      GRATIS
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-3 md:p-5 flex items-start gap-3 md:gap-4" data-id="element-60">
                  <div className="flex-1 min-w-0" data-id="element-61">
                    <h4 className="font-bold text-gray-900 text-sm md:text-base mb-0.5 md:mb-1 leading-tight" data-id="element-62">
                      {bono.title}
                    </h4>
                    <p className="text-gray-600 text-[11px] md:text-sm leading-snug line-clamp-2" data-id="element-63">
                      {bono.desc}
                    </p>
                  </div>
                  <div className={`shrink-0 ${bono.accent} ${bono.text} text-[10px] md:text-xs font-bold px-2 py-1 rounded-md uppercase tracking-wider`} data-id="element-64">
                    30 págs
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="bg-white border-2 border-green-400 rounded-xl md:rounded-2xl p-4 md:p-6 text-center shadow-lg" data-id="element-65">
          <p className="text-[10px] md:text-sm text-gray-500 font-bold uppercase tracking-wider mb-1 md:mb-2" data-id="element-66">
            Valor Total de los 6 Bonos
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 text-lg md:text-3xl font-heading mb-1 md:mb-2" data-id="element-67">
            <span className="text-gray-400 line-through" data-id="element-68">$84.000 ARS</span>
            <span className="text-green-600" data-id="element-69">GRATIS ✅</span>
          </div>
          <p className="text-brand-dark font-medium text-xs md:text-sm" data-id="element-70">
            Incluidos con cualquier oferta
          </p>
        </div>
      </div>
    </section>;
}